import { render, staticRenderFns } from "./PerfReward.vue?vue&type=template&id=7fee027b&scoped=true"
import script from "./PerfReward.vue?vue&type=script&lang=js"
export * from "./PerfReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee027b",
  null
  
)

export default component.exports